import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { fetchLogin, fetchNewPassword } from 'Store/User/thunks';
import { LoginView } from 'Store/User/reducer';
import { getLoginView, getLoginInput, getIsFetchingUser } from 'Store/User/selectors';
import { setLoginView, setLoginEmail, setLoginPassword, clearLogin } from 'Store/User/actions';
import FormLogin from 'Components/FormLogin/FormLogin';
import Spinner from 'Components/Shared/Spinner/Spinner';

interface IProps {
  showCreateOption: boolean;
  onCreateAccount?: () => void;
}

interface IPropsInternal {
  loginView: LoginView;
  userEmail: string;
  isFetching: boolean;
  loginInput: Julius.Website.CustomerLoginViewModel;
  fetchNewPassword: (email: string) => void;
  fetchLogin: (credentials: Julius.Website.CustomerLoginViewModel) => void;
  setLoginView: (loginState: LoginView) => void;
  setLoginEmail: (email: string) => void;
  setLoginPassword: (password: string) => void;
  clearLogin: () => void;
}

type Props = IProps & IPropsInternal;

class FormLoginContainer extends React.PureComponent<Props> {

  onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    this.props.fetchLogin(this.props.loginInput);
  }

  onChange = (e: React.FormEvent<HTMLInputElement>) => {
    const { name, value } = e.currentTarget;
    const setLoginInput = name === 'email' ? 
      this.props.setLoginEmail : this.props.setLoginPassword;

    setLoginInput(value);
  }

  onForgotPassword = () => {
    this.props.setLoginView(LoginView.FORGOT_MESSAGE);
  }

  onSendNewPassword = () => {
    const { email } = this.props.loginInput;
    if (this.isValidEmail(email)) {
      this.props.fetchNewPassword(email);
    }
  }

  isValidEmail = (email: string) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  render() {
    return (
      <FormLogin
        isFetching={ this.props.isFetching }
        currentInput={ this.props.loginInput }
        loginView={ this.props.loginView }
        showCreateOption={ this.props.showCreateOption }
        onChange={ this.onChange }
        onSubmit={ this.onSubmit }
        onCreateAccount={ this.props.onCreateAccount }
        onForgotPassword={ this.onForgotPassword }
        onSendNewPassword={ this.onSendNewPassword }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetchingUser(state),
    loginView: getLoginView(state),
    loginInput: getLoginInput(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchLogin,
    fetchNewPassword,
    setLoginView,
    setLoginEmail,
    setLoginPassword,
    clearLogin,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(FormLoginContainer);


// WEBPACK FOOTER //
// ./src/components/FormLogin/FormLoginContainer.tsx